export default __webpack_public_path__ + "static/media/store.64e6d825.png";